/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PtOtDiagnosisToClinicalCategoryMapping } from './PtOtDiagnosisToClinicalCategoryMapping';
import {
    PtOtDiagnosisToClinicalCategoryMappingFromJSON,
    PtOtDiagnosisToClinicalCategoryMappingFromJSONTyped,
    PtOtDiagnosisToClinicalCategoryMappingToJSON,
    PtOtDiagnosisToClinicalCategoryMappingToJSONTyped,
} from './PtOtDiagnosisToClinicalCategoryMapping';
import type { PtOtClinicalCategoryToCaseMixGroupMapping } from './PtOtClinicalCategoryToCaseMixGroupMapping';
import {
    PtOtClinicalCategoryToCaseMixGroupMappingFromJSON,
    PtOtClinicalCategoryToCaseMixGroupMappingFromJSONTyped,
    PtOtClinicalCategoryToCaseMixGroupMappingToJSON,
    PtOtClinicalCategoryToCaseMixGroupMappingToJSONTyped,
} from './PtOtClinicalCategoryToCaseMixGroupMapping';

/**
 * 
 * @export
 * @interface MedicarePtOtMappings
 */
export interface MedicarePtOtMappings {
    /**
     * 
     */
    diagnosis_to_clinical_category_mappings?: Array<PtOtDiagnosisToClinicalCategoryMapping>;
    /**
     * 
     */
    clinical_category_to_case_mix_group_mappings?: Array<PtOtClinicalCategoryToCaseMixGroupMapping>;
}

/**
 * Check if a given object implements the MedicarePtOtMappings interface.
 */
export function instanceOfMedicarePtOtMappings(value: object): value is MedicarePtOtMappings {
    return true;
}

export function MedicarePtOtMappingsFromJSON(json: any): MedicarePtOtMappings {
    return MedicarePtOtMappingsFromJSONTyped(json, false);
}

export function MedicarePtOtMappingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicarePtOtMappings {
    if (json == null) {
        return json;
    }
    return {
        
        'diagnosis_to_clinical_category_mappings': json['diagnosis_to_clinical_category_mappings'] == null ? undefined : ((json['diagnosis_to_clinical_category_mappings'] as Array<any>).map(PtOtDiagnosisToClinicalCategoryMappingFromJSON)),
        'clinical_category_to_case_mix_group_mappings': json['clinical_category_to_case_mix_group_mappings'] == null ? undefined : ((json['clinical_category_to_case_mix_group_mappings'] as Array<any>).map(PtOtClinicalCategoryToCaseMixGroupMappingFromJSON)),
    };
}

export function MedicarePtOtMappingsToJSON(json: any): MedicarePtOtMappings {
    return MedicarePtOtMappingsToJSONTyped(json, false);
}

export function MedicarePtOtMappingsToJSONTyped(value?: MedicarePtOtMappings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diagnosis_to_clinical_category_mappings': value['diagnosis_to_clinical_category_mappings'] == null ? undefined : ((value['diagnosis_to_clinical_category_mappings'] as Array<any>).map(PtOtDiagnosisToClinicalCategoryMappingToJSON)),
        'clinical_category_to_case_mix_group_mappings': value['clinical_category_to_case_mix_group_mappings'] == null ? undefined : ((value['clinical_category_to_case_mix_group_mappings'] as Array<any>).map(PtOtClinicalCategoryToCaseMixGroupMappingToJSON)),
    };
}

